import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'cn';

const alertVariants = cva(
  'tw:group/alert tw:relative tw:grid tw:w-full tw:gap-y-0.5 tw:rounded-lg tw:border tw:bg-background tw:px-4 tw:py-3 tw:text-left tw:text-sm tw:text-foreground tw:has-data-[slot=alert-action]:relative tw:has-data-[slot=alert-action]:pr-18 tw:has-[>svg]:grid-cols-[auto_1fr] tw:has-[>svg]:gap-x-3 tw:[&>svg]:self-center tw:[&>svg]:text-current tw:[&>svg:not([class*=size-])]:size-4',
  {
    variants: {
      variant: {
        default: '',
        destructive:
          'tw:text-destructive tw:*:data-[slot=alert-description]:text-destructive tw:[&>svg]:text-current',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  );
}

function AlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        'tw:font-medium tw:group-has-[>svg]/alert:col-start-2 tw:[&_a]:underline tw:[&_a]:underline-offset-3 tw:[&_a]:hover:text-foreground',
        className
      )}
      {...props}
    />
  );
}

function AlertDescription({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        'tw:text-sm tw:font-light tw:text-balance tw:text-foreground tw:group-has-[>svg]/alert:col-start-2 tw:md:text-pretty tw:[&_a]:underline tw:[&_a]:underline-offset-3 tw:[&_a]:hover:text-foreground tw:[&_p:not(:last-child)]:mb-4',
        className
      )}
      {...props}
    />
  );
}

function AlertAction({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-action"
      className={cn('tw:absolute tw:top-2.5 tw:right-3', className)}
      {...props}
    />
  );
}

export { Alert, AlertTitle, AlertDescription, AlertAction };
